"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const currency_1 = require("../../../../app/shared/utils/currency");
const useSimulationStore_1 = require("../../../../stores/useSimulationStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'lease-card',
    props: {
        title: null,
        plazo: null,
        pagoInicial: null,
        montoFinanciado: null,
        montoMensual: null,
        comisionPorApertura: null,
        anticipo: null,
        valorResidual: null,
        bgColor: null,
        active: { type: Boolean }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const store = (0, useSimulationStore_1.useSimulationStore)();
        const displayValue = (0, vue_2.computed)(() => {
            return "$" + store.enganche.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
        });
        const handleClick = () => {
            emit("click");
        };
        return { __sfc: true, props, store, emit, displayValue, handleClick, parseToMexicanPeso: currency_1.parseToMexicanPeso };
    }
});
